export default "__VITE_ASSET__xrPkckte__"